import { useEffect } from "react";

/**
 * Lightweight imperative <head> manager — sets title, description, canonical,
 * og:image, and an optional JSON-LD script tag. Cleans up on unmount.
 */
export function Helmet({ title, description, canonical, ogImage, jsonLd }) {
  useEffect(() => {
    if (title) document.title = title;

    const setMeta = (selector, attr, name, value) => {
      if (!value) return null;
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", value);
      return el;
    };

    const desc = setMeta('meta[name="description"]', "name", "description", description);
    const ogTitle = setMeta('meta[property="og:title"]', "property", "og:title", title);
    const ogDesc = setMeta('meta[property="og:description"]', "property", "og:description", description);
    const ogImg = setMeta('meta[property="og:image"]', "property", "og:image", ogImage);
    const ogUrl = setMeta('meta[property="og:url"]', "property", "og:url", canonical);

    let canonEl = document.head.querySelector('link[rel="canonical"]');
    if (canonical) {
      if (!canonEl) {
        canonEl = document.createElement("link");
        canonEl.setAttribute("rel", "canonical");
        document.head.appendChild(canonEl);
      }
      canonEl.setAttribute("href", canonical);
    }

    let ldEl = null;
    if (jsonLd) {
      ldEl = document.createElement("script");
      ldEl.type = "application/ld+json";
      ldEl.dataset.dynamic = "true";
      ldEl.textContent = JSON.stringify(jsonLd);
      document.head.appendChild(ldEl);
    }

    return () => {
      if (ldEl && ldEl.parentNode) ldEl.parentNode.removeChild(ldEl);
    };
  }, [title, description, canonical, ogImage, jsonLd]);
  return null;
}
